import { defineComponent as _defineComponent } from 'vue'
import { BaseCell, ChipStatus, ChipContext } from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/MoneyV2';

import { NebraskaSizes } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  width?: string;
  borderRadius?: string;
  text: string;
  align?: string;
  isChip?: boolean;
  chipColor?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoneyCell',
  props: {
    width: { default: '100%' },
    borderRadius: { default: NebraskaSizes.Radius.x100 },
    text: null,
    align: { default: 'left' },
    isChip: { type: Boolean, default: false },
    chipColor: { default: 'information' }
  },
  setup(__props: any) {



return { __sfc: true,BaseCell, ChipStatus, ChipContext, Money }
}

})